import * as React from 'react';
import './eksKFLwrapper.scss';

export type EksKFLWrapperProps = React.PropsWithChildren<{
  darkMode?: boolean;
  className?: string;
}>;
export const EksKFLWrapper: React.FC<EksKFLWrapperProps> = (props) => {
  const wrapperClasses = `eks_kfl_wrapper ${
    props.darkMode ? 'dark_mode' : ''
  } ${props.className}`;
  return <span className={wrapperClasses}>{props.children}</span>;
};

export default EksKFLWrapper;
